import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributorStockHistory = (id, page = 1, term = '') => useQuery({ queryKey: [`distributor-stock-history`, id, page, term], queryFn: async () => {
    if(!id) return null
    const callback = await API.get(`/distributors/${id}/stock/history?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useDistributorStockHistory